<template>
  <div class="introduction-box">
    <transition name="introduction-demo">
      <div class="introduction-demo-area" v-show="isaActivated">
        <div class="introduction-title">暮らしのガイドライン</div>
        <ul>
          <li
            class="introduction-list"
            v-for="(n, index) in introductionList"
            :key="index"
            v-html="n"
          ></li>
        </ul>
        <div class="introduction-title2">生活便利帳</div>
        <div class="introduction-list1">
          中国に関するとっておきの話題や生活に関わる基礎知識を様々な角度<br>
          から整理してお届けしています。<br>
          各ジャンルにおけるランキング記事や特集記事など、ユーザー様の関<br>
          心の高いコンテンツのご提供を心がけています。また最新のLBS（位置<br>
          情報サービス）により、より便利なリサーチ機能を兼ね備えています<br>
        </div>
      </div>
    </transition>
    <div class="introduction-image">
      <img :src="partsImage" v-show="isaActivated" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      introductionList: [
        "対象エリアは、北京・上海・広州・深圳・蘇州・天津・大連の6都市を",
        "カバーしており、各エリアのリスティング情報やローカル情報が満載",
        "です。「暮らしの情報」を”見える化”したデータベース。",
        "スポット紹介画面から電話がかけられたり、ハイヤー配車予約ができ",
        "たりします。",
      ],
      shadow: "box-shadow:0px 0px 108px 0px rgba(238,178,94,0.18);",
      partsImage: null,
      isaActivated: false,
    };
  },
  methods: {
    init(partsImage) {
      this.isaActivated = true;
      this.partsImage = partsImage;
      return this.shadow;
    },
    back() {
      this.isaActivated = false;
    },
  },
};
</script>
<style scoped>
.introduction-box {
  width: 100%;
  height: 100%;
  justify-content: space-around;
  display: flex;
  background-color: white;
}
.introduction-image {
  width: 2rem;
}
.introduction-demo-area {
  width: 6.8rem;
  padding-top: 1rem;
  overflow: hidden;
  height: 100%;

  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.introduction-title {
  font-size: 0.6rem;
  font-weight: bold;
  
  color: #50391e;
}
.introduction-title2 {
  padding-top: 0.2rem;
  font-size: 0.3rem;
  font-weight: bold;
  
  color: #50391e;
}
.introduction-title3 {
  padding-top: 0.2rem;
  font-size: 0.15rem;
  font-weight: bold;
  text-indent: 0.1rem;
  color: #50391e;
}
.introduction-list {
  padding-top: 0.1rem;
  font-size: 0.2rem;
  font-weight: normal;
  color: #50391e;
}
.introduction-list1{
   padding-top: 0.1rem;
  font-size: 0.2rem;
  font-weight: normal;
  color: #50391e;
  line-height: 0.35rem;
}
.introduction-image{
  width: 5rem;
}
.introduction-image img {
  
  width: 100%;
  height: auto;
  padding-top: 1rem;
}
.introduction-demo-enter-active,
.introduction-demo-leave-active {
  transition: all 0.5s;
}
.introduction-demo-enter, .introduction-demo-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -6.5rem;
}
.food-bottom-icons {
  display: block;
  margin: 0 auto;
  width: 5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/round-spare-parts/guide.vue